export default "__VITE_ASSET__DpbTvNzI__"